import { analyticsStoreState } from '../stores/analyticsStore.ts';
import { ANALYTICS_SOURCES } from './constant';

const getAnalyticsStoreState = () => {
    const {
        source, userId, persona, username, email,
    } = analyticsStoreState();
    return {
        source,
        userId,
        persona,
        username,
        email,
    };
};

const sourceToBasePayloadMap = {

    [ANALYTICS_SOURCES.TRY_ON]: () => {
        // const commonPayLoad = getAnalyticsStoreState();

        return {
            // ...commonPayLoad,
            eventType: 'USER_ACTION',
        };
    },
};

const eventToFixedPayloadMap = {
    PAGE_VIEW: {
        eventType: 'AUTO',
    },
    LANDING_PAGE_VIEW: { eventType: 'AUTO' },
    SSO_AUTHENTICATION_INITIATE: { eventType: 'AUTO' },
    USER_PERSONA_PAGE_VIEW: { eventType: 'AUTO' },
    CREATOR_PAGE_VIEW: { eventType: 'AUTO' },
    SIGN_UP_USER_DETAILS_PAGE_VIEW: { eventType: 'AUTO' },
    SIGN_UP_VERIFY_OTP_PAGE_VIEW: { eventType: 'AUTO' },
    SIGN_UP_SUCCESS: {
        eventType: 'AUTO',
    },
    USER_FETCHED: {
        eventType: 'AUTO',
    },
    API_ERROR: {
        eventType: 'AUTO',
    },
    CLIENT_ERROR: {
        eventType: 'AUTO',
    },
    MOBILE_VIEW_ERROR: {
        eventType: 'AUTO',
    },
};

export const getAnalyticsData = (source, event, dynamicPayload = {}) => {
    const basePayload = sourceToBasePayloadMap[source]();
    const fixedPayload = eventToFixedPayloadMap[event];

    return {
        ...basePayload, ...fixedPayload, source, event, ...dynamicPayload,
    };
};
